<template>
  <span class="tooltip" v-on="events">
    <slot></slot>
    <span
      ref="content"
      class="tooltip__content"
      :class="{ active: isActive }"
      :style="position"
      ><slot name="tooltip"></slot
    ></span>
  </span>
</template>

<script>
import { convertToUnit } from "@/core/util/helpers";

export default {
  data() {
    return {
      isActive: false,
      position: {}
    };
  },

  computed: {
    events() {
      return {
        mouseenter: e => this.onHover(e),
        mouseleave: e => this.onHover(e)
      };
    }
  },

  mounted() {
    this.calcPosition();
  },

  methods: {
    getActivator(e) {
      return e ? e.currentTarget || e.target : this.$el;
    },

    calcPosition() {
      const activator = this.getActivator();
      const content = this.$refs.content;

      this.position = {
        top: convertToUnit((content.offsetHeight + 15) * -1),
        left: convertToUnit(
          (content.offsetWidth - activator.offsetWidth - 10) * -1
        )
      };
    },

    onHover(e) {
      this.isActive = e.toElement.contains(e.currentTarget || e.target);
    }
  }
};
</script>

<style lang="scss">
.tooltip {
  position: relative;
  display: inline-block;

  &__content {
    position: absolute;
    z-index: 2;
    background: lighten(#19233d, 5%);
    box-shadow: 0 8px 16px 0px #000a25;
    padding: 4px 12px;
    border-radius: 6px;

    font-size: 11px;
    line-height: 15px;
    white-space: nowrap;
    transition: 0.3s;
    user-select: none;
    opacity: 0;
    visibility: hidden;

    b {
      color: #fbc33e;
    }

    &.active {
      opacity: 1;
      visibility: visible;
    }

    &:after {
      position: absolute;
      content: "";
      display: block;
      border: 5px solid transparent;
      border-left-color: lighten(#19233d, 5%);
      border-bottom-color: lighten(#19233d, 5%);
      transform: rotate(-45deg);
      bottom: -5px;
      right: 20px;
      z-index: 3;
    }
  }
}
</style>
